import { Component, Input, OnChanges, OnInit, OnDestroy, input } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "secured-image",
  template: ` <img [src]="imageSrc" (click)="openImage(imageSrc)" alt="Preview" class="cursor-pointer" /> `,
})
export class SecuredImageComponent implements OnInit, OnChanges, OnDestroy {
  // we need HttpClient to load the image and DomSanitizer to trust the url
  constructor(
    private httpClient: HttpClient,
    private domSanitizer: DomSanitizer
  ) {}

  src = input<string>();

  private src$ = new BehaviorSubject(this.src());
  imageSrc: any = "";

  ngOnInit(): void {
    this.src$.subscribe((url) => this.loadImage(url));
  }

  ngOnChanges(): void {
    this.src$.next(this.src());
  }

  ngOnDestroy(): void {
    this.src$.unsubscribe();
  }

  private loadImage(url: string) {
    this.httpClient.get(url, { responseType: "blob" }).subscribe((blob) => {
      this.imageSrc = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
    });
  }

  openImage(imageUrl: string) {
    window.open(imageUrl["changingThisBreaksApplicationSecurity"], "_blank");
  }
}
